import * as actionTypes from '../actions/actionTypes';

const initialState = {
    currentWeekNumber: null,
    isSunday: false,
    loadingCurrentWeekNumber: null,
    loadingEmployees: false,
    employees: [],
    loadingEmployee: false,
    employee: null,
    employeeSchedule: null,
    loadingEmployeeSchedule: false,
    employeeAnnouncements: null,
    loadingEmployeeAnnouncements: null,
    downloadingSchedule: false,
    groupSchedule: null,
    loadingGroupSchedule: false,
    groupAnnouncements: null,
    loadingGroupAnnouncements: null,
    studentGroups: [],
    studentGroupsLoading: false,
    weekFilters: [false, false, false, false]
};

const loadCurrentWeekNumber = (state) => {
    return {
        ...state,
        loadingCurrentWeekNumber: true
    }
}

const setCurrentWeekNumber = (state, action) => {
    const isSunday = new Date().getDay() === 0;
    return {
        ...state,
        currentWeekNumber: action.currentWeekNumber,
        isSunday: isSunday,
        loadingCurrentWeekNumber: false
    }
};

const loadEmployees = (state) => {
    return {
        ...state,
        loadingEmployees: true,
        employees: []
    }
}

const setEmployees = (state, action) => {
    return {
        ...state,
        employees: [...action.employeesData],
        loadingEmployees: false
    }
};

const loadEmployee = (state) => {
    return {
        ...state,
        loadingEmployee: true
    }
}

const setEmployee = (state, action) => {
    return {
        ...state,
        employee: action.employee,
        loadingEmployee: false
    }
};

const loadEmployeeSchedule = (state) => {
    return {
        ...state,
        loadingEmployeeSchedule: true,
    }
}

const setEmployeeSchedule = (state, action) => {
    let tmp = { ...action.employeeSchedule }
    if (action.employeeSchedule instanceof Error)
        return {
            ...state,
            employeeSchedule: new Error(action.employeeSchedule),
            loadingEmployeeSchedule: false
        }
    else
        return {
            ...state,
            employeeSchedule: { ...tmp },
            loadingEmployeeSchedule: false
        }
};

const loadEmployeeAnnouncements = (state) => {
    return {
        ...state,
        loadingEmployeeAnnouncements: true,
    }
}

const setEmployeeAnnouncements = (state, action) => {
    let tmp = [...action.announcements]
    return {
        ...state,
        employeeAnnouncements: [...tmp],
        loadingEmployeeAnnouncements: false
    }
};

const waitScheduleDownload = (state) => {

    return {
        ...state,
        downloadingSchedule: true
    }
}

const setScheduleDownload = (state) => {
    return {
        ...state,
        downloadingSchedule: false
    }
};

const loadGroupSchedule = (state) => {
    return {
        ...state,
        loadingGroupSchedule: true,
    }
}

const setGroupSchedule = (state, action) => {
    if (action.groupSchedule instanceof Error)
        return {
            ...state,
            groupSchedule: new Error(action.groupSchedule),
            loadingGroupSchedule: false
        }
    else
        return {
            ...state,
            groupSchedule: { ...action.groupSchedule },
            loadingGroupSchedule: false
        }
};

const loadGroupAnnouncements = (state) => {
    return {
        ...state,
        loadingGroupAnnouncements: true,
    }
}

const setGroupAnnouncements = (state, action) => {
    let tmp = [...action.announcements]
    return {
        ...state,
        groupAnnouncements: [...tmp],
        loadingGroupAnnouncements: false
    }
};

const getStudentGroupsByNameRequest = (state) => {
    return {
        ...state,
        studentGroupsLoading: true,
    }
}

const getStudentGroupsByNameSuccess = (state, action) => {
    return {
        ...state,
        studentGroupsLoading: false,
        studentGroups: action.payload,
    }
}

const getStudentGroupsFailure = (state) => {
    return {
        ...state,
        studentGroupsLoading: false,
    }
}

const setWeekFilters = (state, action) => {
    return {
        ...state,
        weekFilters: [...action.weekFilters]
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_CURRENT_WEEK: return loadCurrentWeekNumber(state);
        case actionTypes.SET_CURRENT_WEEK: return setCurrentWeekNumber(state, action);
        case actionTypes.LOAD_EMPLOYEES: return loadEmployees(state);
        case actionTypes.SET_EMPLOYEES: return setEmployees(state, action);
        case actionTypes.LOAD_EMPLOYEE: return loadEmployee(state);
        case actionTypes.SET_EMPLOYEE: return setEmployee(state, action);
        case actionTypes.LOAD_EMPLOYEE_SCHEDULE: return loadEmployeeSchedule(state);
        case actionTypes.SET_EMPLOYEE_SCHEDULE: return setEmployeeSchedule(state, action);
        case actionTypes.LOAD_EMPLOYEE_ANNOUNCEMENTS: return loadEmployeeAnnouncements(state);
        case actionTypes.SET_EMPLOYEE_ANNOUNCEMENTS: return setEmployeeAnnouncements(state, action);
        case actionTypes.WAIT_SCHEDULE_DOWNLOAD: return waitScheduleDownload(state);
        case actionTypes.SET_SCHEDULE_DOWNLOAD: return setScheduleDownload(state);
        case actionTypes.LOAD_GROUP_SCHEDULE: return loadGroupSchedule(state);
        case actionTypes.SET_GROUP_SCHEDULE: return setGroupSchedule(state, action);
        case actionTypes.LOAD_GROUP_ANNOUNCEMENTS: return loadGroupAnnouncements(state);
        case actionTypes.SET_GROUP_ANNOUNCEMENTS: return setGroupAnnouncements(state, action);
        case actionTypes.GET_GROUPS_BY_NAME_REQUEST: return getStudentGroupsByNameRequest(state);
        case actionTypes.GET_GROUPS_BY_NAME_SUCCESS: return getStudentGroupsByNameSuccess(state, action);
        case actionTypes.GET_GROUPS_BY_NAME_FAILURE: return getStudentGroupsFailure(state);
        case actionTypes.SET_WEEK_FILTERS: return setWeekFilters(state, action);

        default: return state;
    }
};
export default reducer;